import AxiosDefault from "services/AxiosDefault";

/* ---------------- CREATE DYNAMIC SPACE ---------------- */

export const createDynamicSpaceAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/space/create",
    data,
  });
  return response;
};

/* ---------------- GET DYNAMIC SPACES ---------------- */

export const getDynamicSpacesAPI = async ({ placeId, day }) => {
    console.log("placeId ==>",placeId)
    console.log("day ==>",day)
  const response = await AxiosDefault({
    method: "POST",
    url: "/space/list",
    data: { placeId, day },
  });
  return response;
};

/* ---------------- DELETE / STATUS UPDATE ---------------- */

export const deleteDynamicSpaceAPI = async ({ spaceId, status }) => {
  const response = await AxiosDefault({
    method: "PATCH",
    url: `/space/status/${spaceId}`,
    data: { status },
  });
  return response;
};

/* ---------------- UPDATE DYNAMIC SPACE ---------------- */

export const updateDynamicSpaceAPI = async ({ spaceId, ...rest }) => {
  const response = await AxiosDefault({
    method: "PUT",
    url: `/space/update/${spaceId}`,
    data: rest,
  });
  return response;
};
